
const MAP_SIZES = {
    Erangel_Main: 816000,
    Baltic_Main: 816000,
    Desert_Main: 816000,
    Savage_Main: 408000,
    DihorOtok_Main: 816000,
    Summerland_Main: 204000,
    Chimera_Main: 306000,
    Heaven_Main: 102000,
    Tiger_Main: 816000,
    Kiki_Main: 816000,
    Neon_Main: 816000,
}

// Haritanın tamamını kaplayan daire (köşelerden başlayan ilk mavi alan için).
// Oyun koordinatları genelde 0..size kare; merkez = size/2, yarıçap = köşeye uzaklık.
function getFullMapCircle(mapName) {
    const size = MAP_SIZES[mapName] || 816000
    const half = size / 2
    const radius = (size * Math.SQRT2) / 2
    return { x: half, y: half, radius }
}

const blankIntervalState = () => ({
    players: {},
    playerLocations: {},
    bluezone: null,
    redzone: null,
    safezone: null,
    tracers: [],
    carePackages: [],
})

function getPlayerList(snapshot) {
    const players = snapshot.players
    if (!players) return []
    return players.playerInfoList || players.TotalPlayerList || []
}


function getLocation(player) {
    if (player.posX !== undefined && player.posY !== undefined) {
        return { x: player.posX, y: player.posY }
    }
    if (player.location) {
        const loc = player.location
        return { x: (loc.x != null ? loc.x : loc.posX), y: (loc.y != null ? loc.y : loc.posY) }
    }
    return null
}

function liveStateToStatus(liveState) {
    if (liveState === 5) return 'dead'
    return undefined
}

export default function parsePCOBTelemetry(replayData) {
    if (!replayData || !replayData.meta || !Array.isArray(replayData.snapshots)) {
        throw new Error('Invalid PCOB replay: missing meta or snapshots')
    }
    const { meta, snapshots, kills } = replayData
    let maxT = 0
    for (let i = 0; i < snapshots.length; i++) {
        const t = snapshots[i].t != null ? snapshots[i].t : 0
        if (t > maxT) maxT = t
    }
    const durationSeconds = meta.durationSeconds || (snapshots.length > 0 ? Math.ceil(maxT) + 5 : 600)
    const focusedPlayerName = meta.focusedPlayerName || ''
    const mapName = meta.mapName && MAP_SIZES[meta.mapName] ? meta.mapName : 'Erangel_Main'

    const state = Array((durationSeconds + 5) * 10)
    const globalState = { kills: [], death: null }

    const allPlayers = new Map()
    const teamIdByPlayer = new Map()

    snapshots.forEach(snapshot => {
        const playerList = getPlayerList(snapshot)
        playerList.forEach(p => {
            const name = p.playerName || p.name
            if (name) {
                allPlayers.set(name, p)
                if (p.teamId !== undefined) teamIdByPlayer.set(name, p.teamId)
            }
        })
    })

    const teammatesByPlayer = {}
    allPlayers.forEach((p, name) => {
        const teamId = (p.teamId != null ? p.teamId : teamIdByPlayer.get(name))
        if (teamId === undefined) return
        const teammates = [...allPlayers.keys()].filter(n =>
            n !== name && (allPlayers.get(n).teamId != null ? allPlayers.get(n).teamId : teamIdByPlayer.get(n)) === teamId
        )
        teammatesByPlayer[name] = teammates
    })

    const playersForMatch = [...allPlayers.keys()].map(name => ({
        id: allPlayers.get(name).playerKey || name,
        name,
        rosterId: (allPlayers.get(name).teamId != null ? allPlayers.get(name).teamId : teamIdByPlayer.get(name)) || 0,
    }))

    const match = {
        id: meta.gameId || 'pob',
        mapName,
        gameMode: 'squad',
        playedAt: meta.recordedAt || new Date().toISOString(),
        durationSeconds,
        players: playersForMatch,
    }

    const matchEnd = {
        characters: playersForMatch.map((p, idx) => ({
            character: {
                name: p.name,
                teamId: p.rosterId,
                accountId: String(p.id),
                ranking: idx + 1,
            },
        })),
    }

    for (let i = 0; i < state.length; i++) {
        state[i] = blankIntervalState()
    }

    // Faz bazlı alan bilgileri: her CircleIndex için başlangıç ve hedef çember.
    // start: faz başlarken görülen çember
    // end: bir SONRAKİ faza geçildiğinde (CircleIndex+1) görülen çember
    const phaseDefs = {}
    let lastPhaseIndex

    snapshots.forEach(snapshot => {
        const t = (snapshot.t != null ? snapshot.t : 0)
        const interval = Math.floor(t * 10)

        if (interval < 0 || interval >= state.length) return

        const curState = state[interval]
        const playerList = getPlayerList(snapshot)

        playerList.forEach(p => {
            const name = p.playerName || p.name
            if (!name) return

            const location = getLocation(p)
            const health = (p.health != null ? p.health : 100)
            const healthMax = (p.healthMax != null ? p.healthMax : 100)
            const liveState = (p.liveState != null ? p.liveState : 0)
            const killNum = (p.killNum != null ? p.killNum : 0)
            const damage = (p.damage != null ? p.damage : 0)

            curState.playerLocations[name] = location || { x: 0, y: 0 }
            curState.players[name] = {
                name,
                teammates: teammatesByPlayer[name] || [],
                health: (health / (healthMax || 1)) * 100,
                kills: killNum,
                assists: (p.assists != null ? p.assists : 0),
                damageDealt: damage,
                items: [],
                status: liveStateToStatus(liveState),
                liveState,
            }
        })

        const global = (snapshot.global && snapshot.global.gameGlobalInfo) || snapshot.global
        const rawCircleInfo = snapshot.circle || snapshot.CircleInfo || snapshot.circleinfo
        const circleInfo = rawCircleInfo && (rawCircleInfo.circleInfo || rawCircleInfo)
        const circleIndex = circleInfo && circleInfo.CircleIndex != null
            ? Number(circleInfo.CircleIndex)
            : undefined

        // Circle faz durumu ve ilerleme bilgisi (yalnızca görünürlük için; geometriyi
        // etkilemek zorunda değil).
        if (circleInfo) {
            const status = circleInfo.CircleStatus != null ? Number(circleInfo.CircleStatus) : undefined
            const counter = circleInfo.Counter != null ? Number(circleInfo.Counter) : undefined
            const maxTime = circleInfo.MaxTime != null ? Number(circleInfo.MaxTime) : undefined
            const gameTime = circleInfo.GameTime != null ? Number(circleInfo.GameTime) : undefined

            let progress
            if (typeof counter === 'number' && typeof maxTime === 'number' && maxTime > 0) {
                progress = Math.max(0, Math.min(counter / maxTime, 1))
            }

            curState.circlePhase = {
                index: circleIndex,
                status,
                progress,
                gameTime,
            }
        }

        if (global && global.CircleArray && global.CircleArray.length > 0 && circleIndex && circleIndex > 0) {
            // Faz başlangıç ve hedef çemberlerini tespit et (fazlar arası simülasyon için).
            const rawCircles = global.CircleArray
            const circles = rawCircles
                .map((c, idx) => {
                    const x = parseFloat(c.X != null ? c.X : (c.x != null ? c.x : c.PosX)) || 0
                    const y = parseFloat(c.Y != null ? c.Y : (c.y != null ? c.y : c.PosY)) || 0
                    const radius = parseFloat(
                        c.Size != null ? c.Size : (c.Radius != null ? c.Radius : c.size)
                    ) || 0
                    return { x, y, radius, index: idx + 1 }
                })
                .filter(c => c.radius > 0)

            if (circles.length > 0) {
                const byIndex = circles.slice().sort((a, b) => a.index - b.index)
                const currentCircle = byIndex[Math.min(circleIndex - 1, byIndex.length - 1)]

                if (currentCircle) {
                    const def = phaseDefs[circleIndex] || (phaseDefs[circleIndex] = {})
                    if (!def.start) def.start = currentCircle

                    if (lastPhaseIndex != null && circleIndex === lastPhaseIndex + 1) {
                        const prevDef = phaseDefs[lastPhaseIndex] || (phaseDefs[lastPhaseIndex] = {})
                        if (!prevDef.end) prevDef.end = currentCircle
                    }

                    lastPhaseIndex = circleIndex
                }
            }
        }

        // Uçak rotası: gameGlobalInfo'dan PlaneStart/Stop koordinatları (bir kez set et).
        if (global && !globalState.planePath) {
            const sx = global.PlaneStartLocX != null ? parseFloat(global.PlaneStartLocX) : null
            const sy = global.PlaneStartLocY != null ? parseFloat(global.PlaneStartLocY) : null
            const ex = global.PlaneStopLocX != null ? parseFloat(global.PlaneStopLocX) : null
            const ey = global.PlaneStopLocY != null ? parseFloat(global.PlaneStopLocY) : null
            if (typeof sx === 'number' && typeof sy === 'number' && typeof ex === 'number' && typeof ey === 'number') {
                globalState.planePath = { start: { x: sx, y: sy }, stop: { x: ex, y: ey } }
            }
        }
    })

    const bluezoneDps = []
    const playerLocationsMap = {}
    for (let i = 0; i < state.length; i++) {
        const s = state[i]
        Object.keys(s.playerLocations).forEach(name => {
            (playerLocationsMap[name] = playerLocationsMap[name] || []).push(i)
        })
        if (s.bluezone) bluezoneDps.push(i)
    }

    Object.keys(playerLocationsMap).forEach(playerName => {
        const dps = playerLocationsMap[playerName]
        let dpIdx = 0
        let pointer = { left: undefined, right: dps[dpIdx++] }
        for (let i = 0; i < state.length; i++) {
            if (i === pointer.right) {
                pointer = { left: pointer.right, right: dps[dpIdx++] }
            } else {
                state[i].playerLocations[playerName] = pointer
            }
        }
    })

    if (bluezoneDps.length > 0) {
        let bpIdx = 0
        let bp = { right: bluezoneDps[bpIdx++] }
        for (let i = 0; i < state.length; i++) {
            if (i === bp.right) {
                bp = { left: bp.right, right: bluezoneDps[bpIdx++] }
            } else if (!state[i].bluezone) {
                state[i].bluezone = bp
            }
        }
    }

    for (let i = 1; i < state.length; i++) {
        const s = state[i]
        if (!s.safezone) s.safezone = state[i - 1].safezone
        if (!s.redzone) s.redzone = state[i - 1].redzone
        if (!s.circlePhase) s.circlePhase = state[i - 1].circlePhase
        playersForMatch.forEach(p => {
            if (!s.players[p.name]) {
                s.players[p.name] = state[i - 1].players[p.name] || {
                    name: p.name,
                    teammates: teammatesByPlayer[p.name] || [],
                    health: 0,
                    kills: 0,
                    assists: 0,
                    damageDealt: 0,
                    items: [],
                    liveState: 0,
                }
            }
        })
    }

    // Birinci alan kapanmadan 2. faza geçişi engelle: CircleIndex bazen 2'ye erken geçiyor.
    let phase1CloseSeen = false
    let phase1MoveSeen = false
    const phase1CompleteBy = state.map((s, i) => {
        const cp = s.circlePhase
        if (cp && cp.index === 1 && cp.status === 2) {
            phase1MoveSeen = true
            if (typeof cp.progress === 'number' && cp.progress >= 0.98) phase1CloseSeen = true
        }
        if (cp && cp.index >= 2 && phase1MoveSeen) phase1CloseSeen = true
        return phase1CloseSeen
    })

    // Her faz N için: "faz N kapanması interval i'ye kadar tamamlandı mı?" (bir sonraki faza atlama yok)
    const maxPhase = Math.max(0, ...Object.keys(phaseDefs).map(Number))
    const phaseCompleteBy = { 1: phase1CompleteBy }
    for (let N = 2; N <= maxPhase; N++) {
        let seen = false
        phaseCompleteBy[N] = state.map((s, i) => {
            const cp = s.circlePhase
            if (cp && cp.index === N && cp.status === 2 && typeof cp.progress === 'number' && cp.progress >= 0.98) seen = true
            if (cp && cp.index >= N + 1) seen = true
            return seen
        })
    }

    // Faz bazlı shrink (istenen akış):
    // 1) Birinci güvenli alan belli → beyaz=1. alan, mavi yok (bekleme)
    // 2) Birinci kapanma → mavi haritanın dışından 1. güvenli bölgeye kapanır (moving)
    // 3) İkinci güvenli alan belli → beyaz=2. alan
    // 4) İkinci kapanma → mavi 1. alan sınırından 2. güvenli bölgeye kapanır
    // 5) … 3, 4, 5, 6, 7, 8. alana kadar aynı mantık
    const fullMapCircle = getFullMapCircle(mapName)

    Object.keys(phaseDefs).forEach(key => {
        const phase = Number(key)
        const def = phaseDefs[phase]
        if (!def || !def.start) return

        // Phase 1 closing: start = haritanın dışı (fullMapCircle), target = 1. güvenli bölge (def.start)
        // Phase N closing (N>=2): start = (N-1). alan sınırı, target = N. güvenli bölge (def.start)
        let startCircle
        let targetCircle
        if (phase === 1) {
            startCircle = fullMapCircle
            targetCircle = def.start
        } else {
            const prevDef = phaseDefs[phase - 1]
            startCircle = (prevDef && prevDef.start) || def.start
            targetCircle = def.start
        }

        for (let i = 0; i < state.length; i++) {
            const s = state[i]
            if (!s.circlePhase || s.circlePhase.index !== phase) continue

            // Birinci alan kapanmadan 2+ faza geçilmesin: API bazen CircleIndex=2'yi erken gönderiyor
            if (phase >= 2 && !phase1CompleteBy[i]) {
                const firstSafe = phaseDefs[1] && phaseDefs[1].start
                if (firstSafe) {
                    s.safezone = firstSafe
                    s.bluezone = { x: firstSafe.x, y: firstSafe.y, radius: firstSafe.radius }
                }
                continue
            }

            // Önceki faz kapanması bitmeden bu fazın ekranına geçme (atlama yok)
            if (phase >= 2 && phaseCompleteBy[phase - 1] && !phaseCompleteBy[phase - 1][i]) {
                const prevEnd = phaseDefs[phase - 1] && (phaseDefs[phase - 1].end || phaseDefs[phase].start)
                if (prevEnd) {
                    s.safezone = prevEnd
                    s.bluezone = { x: prevEnd.x, y: prevEnd.y, radius: prevEnd.radius }
                }
                continue
            }

            const { status, progress } = s.circlePhase
            // Her fazda bekleme (status 0/1): beyaz = bu fazın güvenli bölgesi. 2–8. fazda mavi = bir önceki sınırda görünsün.
            if (status === 0 || status === 1) {
                s.safezone = def.start
                if (phase >= 2) {
                    const prevStart = phaseDefs[phase - 1] && phaseDefs[phase - 1].start
                    if (prevStart) {
                        s.bluezone = { x: prevStart.x, y: prevStart.y, radius: prevStart.radius }
                    } else {
                        s.bluezone = null
                    }
                } else {
                    s.bluezone = null
                }
                continue
            }

            // Kapanma (status 2): mavi alan startCircle → targetCircle interpolasyonu; beyaz = kapanma hedefi (targetCircle)
            let blue = startCircle
            if (status === 2 && targetCircle && typeof progress === 'number') {
                const p = Math.max(0, Math.min(progress, 1))
                blue = {
                    x: startCircle.x + ((targetCircle.x - startCircle.x) * p),
                    y: startCircle.y + ((targetCircle.y - startCircle.y) * p),
                    radius: startCircle.radius + ((targetCircle.radius - startCircle.radius) * p),
                }
            }

            s.bluezone = { x: blue.x, y: blue.y, radius: blue.radius }
            s.safezone = targetCircle || startCircle
        }
    })

    state.matchEnd = matchEnd

    const killSet = new Set()
    ;(kills || []).forEach((k, i) => {
        const key = `${k.CauserName || k.causerName}-${k.VictimName || k.victimName}-${k.CurGameTime || k.curGameTime}`
        if (killSet.has(key)) return
        killSet.add(key)
        const gameTime = parseFloat(k.CurGameTime || k.curGameTime || 0)
        const msSinceEpoch = gameTime * 1000
        const victimName = k.VictimName || k.victimName
        const causerName = k.CauserName || k.causerName
        globalState.kills.push({ msSinceEpoch, victimName, causerName })
        if (victimName === focusedPlayerName) {
            globalState.death = { msSinceEpoch, killedBy: causerName || 'Unknown' }
        }

        // Basit "ateş etti" görselleştirmesi: her kill için kısa süreli tracer ekle.
        if (causerName && victimName && causerName !== victimName) {
            const interval = Math.floor(msSinceEpoch / 100)
            const startInterval = Math.max(0, interval - 10) // ~1s geri
            const endInterval = interval
            ;(state[startInterval] || (state[startInterval] = blankIntervalState())).tracers.push({
                key: i,
                attackerName: causerName,
                victimName,
                startInterval,
                endInterval,
            })
        }
    })

    return { match, state, globalState, focusedPlayerName }
}



// WEBPACK FOOTER //
// ./src/models/PCOBTelemetry.parser.js